import React, { Fragment, useState } from 'react'
import { formatDbDate } from '../../utils/dateFormater';
import { formatWhatsAppNumber } from '../../utils/whatsappLinkFormater';
import SingleOrderButtons from './SingleOrderButtons';

const SingleReservation = ({ order, user, selectedOrders, setSelectedOrders }) => {




    const [copied, setCopied] = useState(false);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };






    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";
        if (orderStatus === "ORDER_CANCELLED_BY_PMM") return "text-red-500 bg-red-100";

    }











    return (
        <Fragment>
            <div 
                className="grid py-[1vmax] items-center border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                style={{ gridTemplateColumns: 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 2.2fr) minmax(0, 1.8fr) minmax(0, 3fr)' }}
            >
                {/* Select */}
                <div className="flex-center text-[#4c4c5c] text-[1.3vmax] lg:text-[0.9vmax]" >
                    <input
                        type="checkbox"
                        checked={selectedOrders?.includes(order.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedOrders(prev => [...prev, order.id]);
                            } else {
                                setSelectedOrders(prev => prev.filter(id => id !== order.id));
                            }
                        }}
                        className="cursor-pointer"
                    />
                </div>

                {/* Order ID */}
                <div className="text-center text-[#4c4c5c] font-bold text-[1.3vmax] lg:text-[0.9vmax]" >
                    #{order?.id}
                </div>

                {/* Product ID */}
                <div className="flex-center text-[#4c4c5c] font-bold text-[1.3vmax] lg:text-[0.9vmax] flex gap-[0.5vmax] items-center" >
                    <span className="text-gray-600">{order?.product_id}</span>
                    <button
                        onClick={() => handleCopy(order?.product_id)}
                        className="text-gray-400 hover:text-indigo-600 transition-colors"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"} text-[1vmax]`}></i>
                    </button>
                </div>

                {/* Seller */}
                <div className="flex-center flex-col text-[#4c4c5c] text-[1.3vmax] lg:text-[0.9vmax]" >
                    <a href={formatWhatsAppNumber(order?.pmm_country_code, order?.pmm_phone_number)} target="_blank" rel="noopener noreferrer" className="mb-[0.5vmax] hover:scale-110 transition-transform">
                        <i className="fa-brands fa-whatsapp text-green-600 text-[1.8vmax]"></i>
                    </a>
                    <div className='text-center font-bold text-gray-700 capitalize tracking-tight leading-tight'>{order?.pmm_name}</div>
                </div>

                {/* PM */}
                <div className="flex-center flex-col text-[#4c4c5c] text-[1.3vmax] lg:text-[0.9vmax]" >
                    <a href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} target="_blank" rel="noopener noreferrer" className="mb-[0.5vmax] hover:scale-110 transition-transform">
                        <i className="fa-brands fa-whatsapp text-green-600 text-[1.8vmax]"></i>
                    </a>
                    <div className='text-center font-bold text-gray-700 capitalize tracking-tight leading-tight'>{order?.pm_name}</div>
                </div>

                {/* PM Earnings */}
                <div className="flex-center font-bold text-gray-700 text-[1.3vmax] lg:text-[0.9vmax]" >
                    {order?.pm_commission_amount ? `Rs. ${order?.pm_commission_amount}` : "Rs. 0.00"}
                </div>

                {/* Portal Earnings */}
                <div className="flex-center font-bold text-gray-700 text-[1.3vmax] lg:text-[0.9vmax]" >
                    {order?.portal_commission_amount ? `Rs. ${order?.portal_commission_amount}` : "Rs. 0.00"}
                </div>

                {/* Refunded At */}
                <div className="text-center text-gray-500 font-medium text-[1.3vmax] lg:text-[0.95vmax] whitespace-nowrap" >
                    {formatDbDate(order?.updated_at)}
                </div>

                {/* Status */}
                <div className="flex-center" >
                    <span className={`text-[1.3vmax] lg:text-[0.85vmax] font-bold uppercase p-[0.3vmax_0.8vmax] rounded-lg shadow-sm ${handleClassName(order?.status)}`} >
                        {order?.status === "ON_HOLD" ? "ON HOLD" : 
                         order?.status === "REVIEW_DELETED" ? "REVIEW DELETED" : 
                         order?.status === "SYSTEM_CANCELLED" ? "SYSTEM CANCEL" : 
                         order?.status === "ORDER_CANCELLED_BY_PMM" ? "PMM CANCEL" :
                         order?.status}
                    </span>
                </div>

                {/* Actions */}
                <div className="flex-center">
                    <SingleOrderButtons order={order} user={user} />
                </div>
            </div>
        </Fragment>
    )
}

export default SingleReservation